import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import {
  Dialog,
  AppBar,
  Toolbar,
  Slide,
} from '@mui/material';
import VibeIcon from '../VibeIcon/VibeIcon';
import viClose from '../../icons/viClose';
import viIsmLogo from '../../icons/viIsmLogo';
import * as color from '../../sass/color.scss';
import './VibeDialog.scss';

// const styles = {
//   toolbarGutters: {
//     alignItems: 'center',
//     display: 'flex',
//     justifyContent: 'space-between',
//     margin: '5px 0 0 15px',
//   },
//   title: {
//     color: '#383838',
//     fontSize: 24,
//     fontWeight: 'normal',
//     lineHeight: 1,
//     letterSpacing: '1.6px',
//   },
// };

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function VibeDialog({
  title = null,
  children,
  open = false,
  fullScreen = false,
  closeDialogLink = null,
  testIds = {
    root: undefined,
    close: undefined,
  },
  onClose = () => {},
}) {
  const closeDialogIcon = (
    <VibeIcon
      className="close-icon"
      icon={viClose}
      color={color.manatee}
      hoverColor={color.manatee16}
      size={24}
      onClick={onClose}
      data-testid={testIds?.close}
    />
  );

  const closeDialogHtml = closeDialogLink ? (
    <Link
      to={closeDialogLink}
      data-testid={testIds?.close}
    >
      {closeDialogIcon}
    </Link>
  ) : closeDialogIcon;
  
  return (
    <Dialog
      className="VibeDialog"
      fullScreen={fullScreen}
      open={open}
      slots={{
        transition: Transition,
      }}
      disableEnforceFocus
      data-testid={testIds?.root}
    >
      {title ? (
        <AppBar className="app-bar" position="sticky">
          <Toolbar
            sx={{
              justifyContent: 'space-between',
            }}
          >
            <VibeIcon
              icon={viIsmLogo}
              color={color.white}
              size={48}
            />

            <h1 className="wizard-title">
              {title}
            </h1>

            <div className="right-bar-items">
              {closeDialogHtml}
            </div>
          </Toolbar>
        </AppBar>
      ) : null}

      {children}
    </Dialog>
  );
}

VibeDialog.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  /** Open the dialog */
  open: PropTypes.bool,
  /** Dialog is full screen */
  fullScreen: PropTypes.bool,
  /** Transition direction */
  transitionDirection: PropTypes.oneOf([
    'up',
    'left',
  ]),
  /** Link when dialog is closed */
  closeDialogLink: PropTypes.string,
  /** data-testid attributes for E2E test selectors */
  testIds: PropTypes.shape({
    root: PropTypes.string,
    close: PropTypes.string,
  }),
  /** When the dialog is closed */
  onClose: PropTypes.func,
};

export default VibeDialog;
